import React from 'react';
import { Dialog, Button, Text } from '@leverege/ui-elements';
import { cancelLocatorReset } from '../../util/Interface';
import S from './ResetLocator.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default class CancelResetLocatorDialog extends React.Component {
  cancelResetLocators = () => {
    const {
      onClose,
      locators
    } = this.props;
    locators.forEach(locator => {
      const systemId = locator?.systemId;
      const locatorId = locator?.id;
      cancelLocatorReset(systemId, locatorId);
    });
    onClose();
  };
  render() {
    const {
      show,
      onClose,
      locators,
      numInvalidLocators
    } = this.props;
    let okText, dialogText;
    if (locators.length > 1) {
      okText = `Cancel Reset for ${locators.length} Locators`;
      dialogText = /*#__PURE__*/_jsxs(Text, {
        children: ["These locators are in the process of being reset, which may take up to 24 hours. ", /*#__PURE__*/_jsx("b", {
          children: "Would you like to cancel the reset process for these locators?"
        })]
      });
    } else {
      okText = 'Cancel Reset for Locator';
      dialogText = /*#__PURE__*/_jsxs(Text, {
        children: ["This locator is in the process of being reset, which may take up to 24 hours. ", /*#__PURE__*/_jsx("b", {
          children: "Would you like to cancel the reset process?"
        })]
      });
    }
    return /*#__PURE__*/_jsx(Dialog.Question, {
      show: show,
      title: "Cancel Locator Reset",
      icon: "fa fa-refresh",
      okay: okText,
      okayVariant: "primaryDestructive",
      cancel: "Nevermind",
      onOkay: this.cancelResetLocators,
      onClose: onClose,
      onCancel: onClose,
      children: dialogText
    });
  }
}